import styled from 'styled-components';

import { theme } from '@styles/theme';

/**
 * Shared reset for the feature's hand-rolled clickable containers
 * (workspace header, section header, selectable journey card, trigger chip).
 *
 * Only `border`, `cursor` and the focus-visible ring are common to all four —
 * `background`/`padding`/`display` differ per site (the trigger chip in
 * particular keeps a background colour and non-zero padding), so those stay
 * on each call site's own `styled(RawButton)({...})`.
 */
export const RawButton = styled.button({
  border: 'none',
  cursor: 'pointer',
  '&:focus-visible': {
    outline: 'none',
    boxShadow: theme.shadow.focus,
  },
});
